import { i18n } from '../i18n/translate';
import { getTitlePrefix } from './titleConfig';

export const getDisplayPageTitle = (title: unknown): string => {
  if (typeof title !== 'string') {
    return '';
  }

  const displayTitle = title.trim();
  const missingTitlePattern = /^(undefined|null)(\s+(undefined|null))*$/i;

  if (!displayTitle || missingTitlePattern.test(displayTitle)) {
    return '';
  }

  return displayTitle;
};

export const getPageTitleFromDocumentTitle = (
  documentTitle: unknown,
  prefix: string | undefined = getTitlePrefix()
): string => {
  const displayTitle = getDisplayPageTitle(documentTitle);

  if (!displayTitle) {
    return '';
  }

  if (prefix && typeof prefix === 'string' && displayTitle.startsWith(prefix)) {
    return getDisplayPageTitle(displayTitle.slice(prefix.length));
  }

  return displayTitle;
};

export const reactifiPageTitle = (title: unknown, prefix?: unknown): void => {
  const displayTitle = getDisplayPageTitle(title);

  if (!displayTitle || typeof document === 'undefined') {
    return;
  }

  const activePrefix = getDisplayPageTitle(prefix) || getDisplayPageTitle(getTitlePrefix()) || '%s';
  const titleTemplate = activePrefix.includes('%s') ? activePrefix : `${activePrefix} %s`;

  /* i18next-extract-disable-next-line */
  document.title = i18n.t(titleTemplate, { postProcess: 'sprintf', sprintf: [displayTitle] });
};
